export default __webpack_public_path__ + "static/travelrapid_step2-e1131e4ed690a8f0a153e31d80f248f1.svg";